import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import Login from "./view/Login/Login";
import NixOptions, { IOptions } from "./components/NixOptions";
import MainRouter from "./Router";
import { BrowserRouter } from 'react-router-dom';
import "./assets/css/card.css";
import LoadDataToCache from "./components/LoadDataToCache";
import { Toaster } from "react-hot-toast";
import "./assets/theme.scss";
// import { downloadDataFromLink } from "./cache/Load.cache";
// import getCache from "./cache/Get.cache";
import { initDB, useIndexedDB } from "react-indexed-db";
import { DBConfig } from "./db/db.config";
import PublicService from "./Services/public.service";
import { unZipFiles } from "./helpers/fs.helper";
import { downloadAndStoreToCache, downloadDataFromLink } from "./cache/Load.cache";



initDB(DBConfig);

function App() {

  // const { add, getByID, getByIndex, getAll, deleteRecord, update } = useIndexedDB("dicom");


  const [selected, setSelected] = useState<IOptions[]>();

  const [questionCounter, setquestionCounter] = useState(0);
  const [examCounter, setexamCounter] = useState(0);
  const [totalExam, settotalExam] = useState(0);
  const [totalQuestions, settotalQuestions] = useState(0);

  const [loading, setLoading] = useState(false);

  const [exams, setExams] = useState<any[]>([]);



  // const storeDataToIndexDb = async () => {
  //   const liveExamsReq = await PublicService.getAllLiveExams();
  //   const liveExams = liveExamsReq.data.map((data: any) => {
  //     return data._id
  //   })
  //   settotalExam(liveExams.length);

  //   if (!liveExams || liveExams.length === 0) return true;

  //   let examCounter = 0;
  //   setexamCounter(examCounter);

  //   for (const exam of liveExams) {
  //     const examData = await PublicService.getQuestionDataByExamId(exam);
  //     settotalQuestions(examData.data.data.length);
  //     if (examData.data && examData.data.data && examData.data.data.length > 0) {
  //       let questionCounter = 0;
  //       for (const link of examData.data.data) {
  //         const data = await getByIndex("_id", link);
  //         if (!data) {
  //           // await downloadDataFromLink(examData.data.s3Url, link);
  //           const enc_data = await getCache(examData.data.s3Url + "/" + link);
  //           const unzipped_data = await unZipFiles(enc_data)
  //           if (unzipped_data.length > 0) {
  //             const data = await getByIndex("_id", link);
  //             if (!data) {
  //               const added_data = await add({
  //                 _id: link,
  //                 data: unzipped_data
  //               });
  //             }
  //             else {
  //               await deleteRecord(data.id)
  //               const added_data = await add({
  //                 _id: link,
  //                 data: unzipped_data
  //               });
  //             }
  //           }
  //         }
  //         questionCounter = questionCounter + 1;
  //         setquestionCounter(questionCounter)
  //       }
  //     }
  //     examCounter = examCounter + 1;
  //     setexamCounter(examCounter);
  //   }
  //   setLoading(false);
  // }

  // const storeToCache = async () => {
  //   let exams = [];
  //   await PublicService.getAllLiveExams().then(res => {
  //     if(res.status == 200){
  //       exams = res.data.map((data: any) => data._id);
  //     }})

  //     if(exams.length == 0) {
  //       console.log("No exams found")
  //       return;
  //     }

  //     settotalExam(exams.length)
  //     let examCounter = 0;
  //     setexamCounter(examCounter);

  //     for (const exam of exams) {
  //       let imageCounter  = 0;
  //       let totalImages = 0;
        
  //       await PublicService.getQuestionDataByExamId(exam).then(async (res) => {
  //       if(res.status == 200){


  //         localStorage.setItem("onlineUrl", res.data?.s3Url)
          
  //         totalImages = res.data.thumbnails.length + res.data.links.length;
  //         settotalQuestions(totalImages);


  //         console.log("Downloading Links")
  //         if(res.data.links.length > 0){
  //           for(const link of res.data?.links){
  //             await downloadAndStoreToCache(link)
  //             imageCounter = imageCounter + 1;
  //             setquestionCounter(imageCounter)
  //           }
  //         }
  //         console.log("Downloading Links - Complete")


  //         console.log("Downloading Thumbnails")
  //         if(res.data.thumbnails.length > 0){
  //           for(const link of res.data?.thumbnails){
  //             await downloadAndStoreToCache(link)
  //             imageCounter = imageCounter + 1;
  //             setquestionCounter(imageCounter)
  //           }
  //         }
  //         console.log("Downloading Thumbnails - Complete")
  //         examCounter = examCounter + 1;
  //         setexamCounter(examCounter);
  //       }
  //     });
  //   }

  // }


// const storeToCache = async () => {
//     let exams = [];
//     const res = await PublicService.getAllLiveExams();
//     if (res.status === 200) {
//         exams = res.data.map(data => data._id);
//     }

//     if (exams.length === 0) {
//         console.log("No exams found");
//         return;
//     }

//     settotalExam(exams.length);
//     let examCounter = 0;

//     setexamCounter(examCounter);

//     for (const exam of exams) {
//         let totalImages = 0;
//         let imageCounter = 0;
//         setquestionCounter(0);
//         const res = await PublicService.getQuestionDataByExamId(exam);
//         if (res.status === 200) {
//             localStorage.setItem("onlineUrl", res.data?.s3Url);
            
//             totalImages = res.data.thumbnails.length + res.data.links.length;
//             settotalQuestions(totalImages);

//             console.log("Downloading Links");
//             if (res.data.links.length > 0) {
//               for(let i = 0; i < res.data.links.length; i += 10){
//                 const batch = res.data.links.slice(i, i + 10);
//                 const promises = [];
//                 for(const link of batch){
//                   promises.push(downloadAndStoreToCache(link))
//                 }
//                 await Promise.all(promises)
//                 imageCounter = imageCounter + promises.length;
//                 setquestionCounter(imageCounter)
//               }
//             }
//             console.log("Downloading Links - Complete");

//             console.log("Downloading Thumbnails");
//             if (res.data.thumbnails.length > 0) {
//               for(let i = 0; i < res.data.thumbnails.length; i += 10){
//                 const batch = res.data.thumbnails.slice(i, i + 10);
//                 const promises = [];
//                 for(const link of batch){
//                   promises.push(downloadAndStoreToCache(link))
//                 }
//                 await Promise.all(promises)
//                 imageCounter = imageCounter+ promises.length;
//                 setquestionCounter(imageCounter)
//               }
//             }
//             console.log("Downloading Thumbnails - Complete");

//             examCounter += 1;
//             setexamCounter(examCounter);
//         }
//     }
// }










  // const getDATA = async() => {
  //   console.log( await getCache("https://exmdcm.objectstore.e2enetworks.net/62bad0a312b267768c3d2aa9"))

  // }
  useEffect(() => {
    if (!loading) {
      setLoading(true);
      // storeDataToIndexDb();
      // storeToCache()

    }
    // LoadCache(setCounter, counter);
    // console.log(getDATA())
  }, [])


  // useEffect(() => {
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  // const handleBeforeUnload = (e:any) => {
  //   e.preventDefault();
  //   const message =
  //     "Are you sure you want to leave?";
  //   e.returnValue = message;
  //   return message;
  // };



  /* View in fullscreen */


  return (
    <div className="App">
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      {/* <LoadDataToCache /> */}
      <BrowserRouter>
        <MainRouter counter={{
          questionCounter,
          examCounter,
          totalExam,
          totalQuestions
        }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
  